
import bildEinsPerson from '@/assets/icons/personen_1.svg';
import bildZweiPerson from '@/assets/icons/personen_2.svg';
import bildDreiPerson from '@/assets/icons/personen_3.svg';
import bildVierPerson from '@/assets/icons/personen_4.svg';
import bildMehrPerson from '@/assets/icons/personen_5.svg';

export const numberPersons = [
    { name: 'Eine Person', available: true, value: 'one', api: '19777', image: bildEinsPerson },
    { name: 'Zwei Personen', available: true, value: 'two', api: '19778',  image: bildZweiPerson },
    { name: 'Drei Personen', available: true, value: 'three', api: '19779', image: bildDreiPerson },
    { name: 'Vier Personen', available: true, value: 'four', api: '19780', image: bildVierPerson },
    { name: 'Fünf Personen und mehr', available: true, value: 'five', api: '20298', image: bildMehrPerson },
];

export const numberPersonsApi = {parameter: '17060', type: 'value_choice'}

